export default __webpack_public_path__ + "static/media/TRASH BIN.68e8e715.svg";